// removed by extract-text-webpack-plugin
module.exports = {"base":"Paginator_base--1-saa","page":"Paginator_page--2csI0","page_active":"Paginator_page_active--3ZG4O","pageActive":"Paginator_page_active--3ZG4O"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/Paginator/Paginator.scss
// module id = 2318
// module chunks = 11